<template>
  <validation-observer ref="formObserver" v-slot="{ passes }" tag="div">
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 6: Final Details
    </h2>
    <form @submit.prevent="passes(goToNextPage)">
      <d-field class="mb-1">
        <d-checkbox v-model="recentlyBidAProjectRequiringQCP">
          We have recently bid a project requiring QCP certification.
        </d-checkbox>
      </d-field>
      <d-field>
        <d-checkbox v-model="haveBeenAwardedContractRequiringQCP">
          We have been awarded a contract for a project requiring QCP certification.
        </d-checkbox>
      </d-field>
      <d-field label="Join Reason">
        <d-input v-model="joinReason" aria-label="reason for joining" type="textarea" placeholder="Please tell us why you are applying to the program" required />
      </d-field>

      <d-field label="QCP Non-Refundable Application Fee Schedule - Please select an option below:" rules="required">
        <div>
          <div class="mb-2">
            <d-radio v-model="awiStatus" native-value="I am a current or would like to become an AWI Manufacturing/Industry Member" required class="items-start">
              <strong>$2,000</strong> - I am a current or would like to become an AWI Manufacturing/Industry Member
            </d-radio>
            <p class="ml-10 mb-1 mt-2 italic">
              Become an AWI Member for an additional $2,200   Find more details here <a href="https://www.awinet.org/membership/membership-overview" target="_blank" rel="noopener noreferrer">https://www.awinet.org/membership/membership-overview</a> or contact Taylor Shaughnessy 571.323.3615 for further information.
            </p>
          </div>
          <div class="mb-2">
            <d-radio v-model="awiStatus" native-value="Non AWI Manufacturing/Industry QCP Application Fee" required class="items-start">
              <strong>$3,500</strong> - Non AWI Manufacturing/Industry QCP Application Fee
            </d-radio>
          </div>
        </div>
      </d-field>

      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </validation-observer>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { APPLY_FOR_LICENSING_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('applyForLicensing');

  export default {
    parent: true,

    computed: {
      ...mapFields({
        fields: ['recentlyBidAProjectRequiringQCP', 'haveBeenAwardedContractRequiringQCP', 'joinReason', 'awiStatus'],
        module: 'applyForLicensing',
        base: 'formFields',
        mutation: APPLY_FOR_LICENSING_FORM.FORM_FIELDS,
      }),
    },

    watch: {
      awiStatus(val) {
        switch (val) {
          case 'I am a current AWI Manufacturing/Industry Member':
            return this.setPrice(2000);
          case 'Non AWI Manufacturing/Industry QCP Application Fee':
            return this.setPrice(3500);
          case 'I am interested in becoming an AWI Manufacturing/Industry Member for an additional $2,200':
            return this.setPrice(3980);
          default:
        }
      },
    },

    methods: {
      ...mapActions([
        'setPrice',
        'goToPrevPage',
        'goToNextPage',
      ]),
    },

  };
</script>